import React from "react";
import { useEffect, useState, useRef } from "react";
import UserStep from "../../newAccount/main/components/UserStep";
import Storage from "@/app/core/util/Storage";
import { toast } from "react-toastify";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { PhoneController } from "@/app/core/base/controllers/PhoneController";
import PhoneModal from "@/app/core/layouts/main-components/users/PhoneModal";

export default function UserProfile(props) {
    const [data, setData] = useState(Storage.getUserData());
    const [picture, setPicutre] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [phones, setPhones] = useState([]);
    const inputFile = useRef(null);

    useEffect(() => {
        loadAccount();
        loadPhones();
    }, []);

    function onUploadClick() {
        inputFile.current.click();
    }

    function loadAccount() {
        AccountController.Get(Storage.getUserData().id, res => {
            Storage.setUserData({ ...data, ...res });
        });
    }

    function saveAccount() {
        AccountController.Update(data, res => {
            toast.success(Translate(Message.Saved));
            loadAccount();
        })
        setTimeout(() => {
            toast.success(Translate(Message.Saved));
        }, 450)
    }

    function removePicture() {
        if (data.id != undefined) {
            if (window.confirm(Translate(Message.DeleteConfirm))) {

                loadAccount();
            }
        }
    }

    function uploadPicture(files) {
        if (data.id != undefined) {

        }
    }

    function handleChange(evt) {
        setData(OnDataChange(data, evt));
    }

    async function loadPhones() {
        await PhoneController.List(res => setPhones(res));
    }

    async function deletePhone(id) {
        if (window.confirm(Translate(Message.DeleteConfirm))) {
            PhoneController.Delete(id, res => {
                toast.success(Message.DeleteSuccess);
                loadPhones()
            })
        }
    }

    return (
        <div className="content">
            <div className="">
                <h3 className="text-muted"><i className="fa fa-arrow-left mr-1" /> Perfil</h3>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div class="text-center">
                        <img className="img-avatar img-avatar-thumb border-gray border-2x border" src={picture && picture.url != undefined ? picture.url : "assets/media/avatars/avatar16.jpg"}
                            onClick={() => onUploadClick()} />
                        <br />
                        <button className="btn btn-dual btn-sm" onClick={() => removePicture()}><i className="si si-close" /></button>
                    </div>
                    <div class="p-3  text-center">
                        <span className="font-w700">
                            {data.firstName} {" "}
                            {data.lastName}
                        </span>
                        <br />
                        <span className="font-w400">
                            {data.email}
                        </span>
                    </div>
                    <div class="p-3">
                        <UserStep data={data} update={true} handleChange={evt => handleChange(evt)} />
                        <button className="btn btn-block btn-hero-lg btn-hero-warning" onClick={() => saveAccount()}>
                            Salvar alterações
                        </button>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="block block-tranparent block-bordered block-rounded">
                        <div className="block-header">
                            <div className="block-title">Telefones para contato</div>
                            <div className="block-tools">
                                <button className="btn btn-dual" onClick={() => setShowModal(true)}>
                                    Adicionar telefone
                                </button>
                            </div>
                        </div>
                        <div className="block-content">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Telefone</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {phones && phones.map(item => (
                                        <tr>
                                            <td>{`+${item.countryCode} (${item.areaCode}) ${item.number}`}</td>
                                            <td>
                                                <button className="btn btn-dual text-danger" onClick={() => deletePhone(item.id)}>
                                                    <i className="si si-close" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <input
                type="file"
                ref={inputFile}
                onChange={(event) => {
                    uploadPicture(event.currentTarget.files);
                }}
                style={{ visibility: "hidden", width: 10 }}
            />
            <PhoneModal
                show={showModal}
                onHide={() => setShowModal(false) | loadPhones()}
            />
        </div>
    )
}